import { render } from "./ReviewDetail.vue?vue&type=template&id=baad332e&scoped=true"
import script from "./ReviewDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDetail.vue?vue&type=script&lang=js"

import "./ReviewDetail.vue?vue&type=style&index=0&id=baad332e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baad332e"]])

export default __exports__